module.exports = __webpack_public_path__ + "static/media/bg-moving-around.7fbc088c.png";